import FETCH from "../utils/fetch";
import ROUTES from "../config/routes";

const fetchPlaidLogs = async (page, limit) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let queryParams = `page=${page}&limit=${limit}`;

  if (userRole === "Financial Advisor Client" && ID) {
    queryParams += `&clientId=${ID}`;
  }

  let res = await FETCH.get({
    url: `${ROUTES.PLAID_LOGS}?${queryParams}`,
  });
  console.log("fetchPlaidLogs response:", res);
  return res;
};

const fetchPlaidWebhookUpdates = async (page, limit) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let queryParams = `page=${page}&limit=${limit}`;

  if (userRole === "Financial Advisor Client" && ID) {
    queryParams += `&clientId=${ID}`;
  }

  let res = await FETCH.get({
    url: `${ROUTES.PLAID_WEBHOOK_UPDATES}?${queryParams}`,
  });
  console.log("fetchPlaidWebhookUpdates response:", res);
  return res;
};
const updatePlaidAccount = async (body) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.post({
    url:
      userRole === "Financial Advisor Client" && ID
        ? `${ROUTES.PLAID_ACCOUNT_UPDATE}?clientId=${ID}`
        : `${ROUTES.PLAID_ACCOUNT_UPDATE}`,
    body,
  });
  console.log("updatePlaidAccount response:", res);
  return res;
};

const buildQueryParams = (params) => {
  const queryParams = Object.entries(params).filter(
    ([, value]) => value !== undefined && value !== null && value !== ""
  );

  return queryParams.length
    ? `?${queryParams
        .map(
          ([key, value]) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        )
        .join("&")}`
    : "";
};

const fetchPlaidCostConfig = async (page, limit) => {
  let res = await FETCH.get({
    url: `${ROUTES.PLAID_COST_CONFIG}${buildQueryParams({ page, limit })}`,
  });
  return res;
};

const fetchPlaidCostProductPricing = async (page, limit, plaidProduct) => {
  let res = await FETCH.get({
    url: `${ROUTES.PLAID_PRODUCT_PRICING}${buildQueryParams({
      page,
      limit,
      plaidProduct,
    })}`,
  });
  return res;
};

const updatePlaidCostConfig = async (body) => {
  let res = await FETCH.put2({
    url: ROUTES.PLAID_COST_CONFIG,
    body,
  });
  return res;
};

const updatePlaidCostProductPricing = async (body) => {
  let res = await FETCH.put2({
    url: ROUTES.PLAID_PRODUCT_PRICING,
    body,
  });
  return res;
};

const fetchPlaidSyncStatus = async (module = "Plaid") => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.PLAID_SYNC_STATUS}?module=${module}&clientId=${ID}`
        : `${ROUTES.PLAID_SYNC_STATUS}?module=${module}`,
  });
  console.log("fetchPlaidSyncStatus response:", res);
  return res;
};

const PLAID_API = {
  fetchPlaidLogs,
  fetchPlaidWebhookUpdates,
  updatePlaidAccount,
  fetchPlaidCostConfig,
  fetchPlaidCostProductPricing,
  updatePlaidCostConfig,
  updatePlaidCostProductPricing,
  fetchPlaidSyncStatus,
};
export default PLAID_API;
